import {compare_versions} from "util/version";
import {SLS_about} from "lib/sls";
import {ALEXMonitor_Status} from 'lib/alexmonitor';

/* Here we check if we should be using the new HTTP Scanner Interface.
 * If any of the following three checks pass, we use the HTTP interface (instead of sockets):
 *      1) Smart Lab Service is installed (over old water link connect service).
 *      2) Test Connect version is the new one.
 *      3) ALEX Pro Monitor is available (it is being added at the same time as the new HTTP interface).
 *
 * Furthermore, we will continue to recheck these items until we confirm the client has
 * installed the new Smart Lab Service (item 1). Once confirmed, we save the value in localStorage.
 */
const IS_NEW_SLS_VERSION_LS_KEY = "isNewSLSVersion";

const SLS_VERSION_TO_PASS = "2.10.0.6";

const MONITOR_ENDPOINT = "";

const REQUEST_TIMEOUT = 5000;

function getUseHTTPScannerInterface() {
    // If key exists in localStorage return early.
    if (localStorage.getItem(IS_NEW_SLS_VERSION_LS_KEY) !== null) return Promise.resolve(localStorage.getItem(IS_NEW_SLS_VERSION_LS_KEY)==="true");

    // Custom promise resolution that will immediately resolve when a promise returns true.
    // Otherwise when all promises complete or the timeout is reached, 
    return new Promise((resolve, reject) =>{
        let timedout = false;

        const timeout = setTimeout(() => {
            timedout = true;
            console.error(new Error("getUseHTTPScannerInterface request timed out."));
            resolve(false);
        }, REQUEST_TIMEOUT);

        let promise_results = [];
        let promise_list = [checkSLSVersion(), checkMonitorInstalled()];
        promise_list.map((promise) => {

            promise.then(
                (result) => {
                    // Once any promise resolves true, immeditately resolve the overarching promise.
                    if(result === true){
                        clearTimeout(timeout);
                        if (!timedout) resolve(true);
                    }else{
                        promise_results.push(result);
                    }
                },
                (error) => {
                    // On error, log the error but wait for other requests to finish.
                    promise_results.push(false);
                    console.error(error);
                }
            ).finally(() => {
                //Check if all promises have completed (and last one was unsuccesful to avoid calling resolve twice).
                if(promise_results.length === promise_list.length){

                    // We return false here because it is only possible to execute this if no promises returned true.
                    clearTimeout(timeout);
                    if (!timedout) resolve(false);
                }
            });

        }); 
    });
}

// Makes a request to the Smart Lab service on localhost that returns the version.
function checkSLSVersion(){
    return SLS_about()
    .then((response) => {
            // Ensure version was returned by the service.
            if (typeof(response.ServiceVersion) === "undefined"){
                throw new Error("No version returned in SLS 'about' response.");
            }

            // Check if version is new enough and set the localStorage value if it is so we stop checking.
            let isNewSLSVersion = (compare_versions(response.ServiceVersion, SLS_VERSION_TO_PASS) >= 0);
            if (isNewSLSVersion) localStorage.setItem(IS_NEW_SLS_VERSION_LS_KEY, isNewSLSVersion);
            return isNewSLSVersion;
        });
}

// Makes a request to localhost on the port that ALEX Pro Monitor should be listening on.
function checkMonitorInstalled(){
    return ALEXMonitor_Status()
    .then( _ => true);
}

// This is a promise that resolves to a boolean indicating if the new HTTP scanner interface should be used.
export const UseHTTPScannerInterface = getUseHTTPScannerInterface();